export default "__VITE_ASSET__Dm1zx1Xa__"